<template>
  <v-dialog :value="show" width="640" @click:outside="cancel">
    <v-card>
      <v-card-title class="headline">{{ title }}</v-card-title>
      <v-card-text v-if="!!text">
        <div>{{ text }}</div>
        <v-text-field
          v-model="reason"
          :label="$t('instructions.revokeAll.revoke.label')"
          required
        />

        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="$options.filters.date(readDate)"
              :label="$t('instructions.markAsRead.create.dateLabel')"
              :hint="$t('instructions.markAsRead.create.dateHint')"
              :persistent-hint="menu"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              clearable
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="readDate"
            :active-picker.sync="activePicker"
            :max="
              new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                .toISOString()
                .substring(0, 10)
            "
            @change="menu = false"
            first-day-of-week="1"
            no-title
            scrollable
          ></v-date-picker>
        </v-menu>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="cancel()">{{
          $t("dialog.cancel")
        }}</v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="confirm()"
          :disabled="disabled"
          >{{ action }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    title: String,
    text: String,
    action: String,
    show: Boolean,
    error: Boolean,
  },
  data() {
    return {
      reason: "",
      readDate: null,

      activePicker: null,
      menu: false,
    };
  },
  computed: {
    disabled() {
      return this.reason === "";
    },
  },
  methods: {
    confirm() {
      this.$emit("confirm", {
        reason: this.reason,
        readDate: this.readDate ? new Date(this.readDate).toISOString() : null,
      });
      this.resetData();
    },
    cancel() {
      this.$emit("cancel");
      this.resetData();
    },
    resetData() {
      this.reason = "";
      this.readDate = null;
    },
  },
};
</script>

<style>
.v-card__text,
.v-card__title {
  word-break: normal;
}
</style>
